export default {
  // 方法集合
  methods: {
    calc() {
      const dEl = document.documentElement
      const clientWidth = dEl.clientWidth
      dEl.style.fontSize = (clientWidth / 1920) * 100 + 'px'
    }
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.calc()
    const resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'
    window.addEventListener(resizeEvt, this.calc)
    document.addEventListener('DOMContentLoaded', this.calc)
  },
  beforeDestroy() {
    const resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'
    window.removeEventListener(resizeEvt, this.calc)
  }
}
